import { Component, HostListener, inject, NgZone, OnInit } from '@angular/core'
//import { PunchService } from '../services/punch.service'
import { CommonModule, NgIf } from '@angular/common'
import { RouterModule } from '@angular/router'
import { Observable } from 'rxjs'
import { User } from '../../../store/auth/auth.state'
import { SharedModule } from '../../../shared/shared.module'
import { ViewChild, ElementRef } from '@angular/core'

//import { AuthService } from '../services/auth.service'
//import { EmployeeService } from '../services/employee.service'
//import { NotificationsService } from 'angular2-notifications'
//import { AdminService } from '../services/admin.service'
//import { ActivatedRoute } from '@angular/router'
//import { firstValueFrom } from 'rxjs'

import {
  ApexNonAxisChartSeries,
  ApexChart,
  ApexResponsive,
  ApexLegend,
  NgApexchartsModule
} from 'ng-apexcharts'
import { UserService } from '../../../services/user.service'
import { AttendancePolicyService } from '../../../services/attendance-policy.service'
import { ClockInClockOutService } from '../../../services/clockIn-clockOut.service'
import { environment } from '../../../../environments/environment'
import { eps } from '../../../services/url.service'

export type ChartOptions = {
  series: ApexNonAxisChartSeries
  chart: ApexChart
  labels: string[]
  responsive: ApexResponsive[]
  legend: ApexLegend
}
interface AttendanceUser {
  id: string
  name: string
  department: string
  avatar: string | null
  firstClockIn: Date
  lastClockOut: Date | null
  totalWorkHours: string
  late: string | null
  production?: string // optional, we can set it to totalWorkHours
}
interface BirthdayUser {
  id: string
  firstName: string
  lastName: string
  picture: string | null
  birthdate: string
  designation?: {
    designationName: string
    department?: { departmentName: string }
  } | null
}

@Component({
  selector: 'app-dashboard',
  imports: [NgIf, CommonModule, RouterModule, SharedModule, NgApexchartsModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  punchInTime: string | null = null
  punchOutTime: string | null = null
  isPunchedIn = false
  totalWorkedHours: number | undefined
  intervalId: ReturnType<typeof setInterval> | undefined
  id: string | number | undefined
  todayDate: string | null | undefined
  public employeeId: string | undefined
  employee: string | null | undefined
  itemData: unknown
  userId: unknown
  public clockInTime: string | null | undefined
  isEmployee = false
  user: any
  public token = ''
  totalWorkedMinutes: number | undefined
  gpsWorkedHours: number | undefined
  gpsWorkedMinutes: number | undefined
  employees$!: Observable<User[]>
  employees!: User[]
  loading = false
  employeeCount = 0
  allEmployees: any[] = []
  filteredEmployees: any[] = []
  departmentCounts: { [key: string]: number } = {}
  totalEmployees = 0

  selectedFilter: 'month' | 'week' | 'lastWeek' | 'year' | 'today' = 'month'
  selectedFilterLabel = 'This Month'
  chartData: { x: string; y: number }[] = []
  increasePercentage: number | null = null
  trendText: string | null = null
  thisPeriodCount = 0
  lastPeriodCount = 0
  xLabels: string[] = []
  maxLimit = 25
  Math = Math
  todayIndex!: number
  points: any[] = []
  segments: any[] = []
  employeeStats = {
    fullTime: { count: 0, percentage: 0 },
    probation: { count: 0, percentage: 0 },
    contract: { count: 0, percentage: 0 },
    inactive: { count: 0, percentage: 0 }
  }
  total = 0
  present = 0
  late = 0
  leave = 0
  absent = 0
  presentCount = 0
  lateCount = 0
  leaveCount = 0
  absentCount = 0
  hasData = false
  tooltip = { show: false, x: 0, y: 0, label: '', value: 0, percent: '' }
  onTimeUsers: any[] = []
  lateUsers: any[] = []
  expandedUser: string | null = null
  public apiEndpoint = environment.apiBaseUrl
  todayBirthdays: BirthdayUser[] = []
  tomorrowBirthdays: BirthdayUser[] = []
  upcomingBirthdays: BirthdayUser[] = []
  todayAnniversaries: any[] = []
  tomorrowAnniversaries: any[] = []
  upcomingAnniversaries: any[] = []
  eps = eps
  chartOptions: any

  selectedFilterOverview: 'month' | 'week' | 'lastWeek' | 'year' | 'today' = 'month'
  selectedFilterOverviewLabel = 'This Month'

  selectedFilterClockInOut: 'month' | 'week' | 'lastWeek' | 'year' | 'today' = 'month'
  selectedFilterClockInOutLabel = 'This Month'
  private userService = inject(UserService)
  private attendancePolicyService = inject(AttendancePolicyService)
  private clockInOutService = inject(ClockInClockOutService)
  @ViewChild('attendanceCanvas')
  attendanceCanvas!: ElementRef<HTMLCanvasElement>

  constructor(private zone: NgZone) {
    //private __adminUserService: AdminService //private __route: ActivatedRoute, //private adminService: AdminService, //private _notifications: NotificationsService, //private employeeService: EmployeeService, //private authService: AuthService, //private datePipe: DatePipe //private punchService: PunchService,
    // const today = new Date();
    // this.todayDate = this.datePipe.transform(today, 'EEE, MMM dd, yyyy');
    // this.todayDate = this.datePipe.transform(today, 'EEE, MMM dd, yyyy, hh:mm:ss a');
    console.log('dashboard')
  }

  ngOnInit(): void {
    // Update the time every second
    //setInterval(() => {
    //  const today = new Date()
    //  this.todayDate = this.datePipe.transform(today, 'EEE, MMM dd, yyyy, hh:mm:ss a')
    //}, 1000) // 1000 milliseconds = 1 second
    //this.userId = this.authService.getUserId()
    //// this.employeeId = 'ab2875ae-418a-4334-b33a-b1a301cf847f';
    //// console.log('employeeid', this.authService.getUserId())

    //const punchData = this.punchService.getPunchData()
    //this.punchInTime = punchData.punchIn
    //this.punchOutTime = punchData.punchOut
    //this.isPunchedIn = !!this.punchInTime && !this.punchOutTime
    ////const today = new Date()
    //if (this.isPunchedIn) {
    //  this.startPunchTimer() // Start timer when the user is punched in
    //}
    //this.getUser()
    //}

    //ngOnDestroy(): void {
    //  if (this.intervalId) {
    //    clearInterval(this.intervalId) // Clear the interval when the component is destroyed
    //  }
    // const today = new Date();
    // const currentYear = today.getFullYear();

    // const params = `year=${currentYear}`;

    // this.userService.getEmployees(params)
    //   .pipe(map(res => res.users))
    //   .subscribe(employees => {
    //     this.allEmployees = employees;
    //     this.applyFilter();
    //   });
    this.setTodayIndex('year')
    this.loadEmployees()
    this.loadChartData()
    this.loadStatusChartData()
    this.loadAttendanceOverview()
    this.loadAttendance()
    this.loadBirthdays()
    this.loadAnniversaries()
  }
  loadEmployees() {
    this.loading = true
    this.userService.getFiveEmployees().subscribe({
      next: res => {
        this.employees = res
        this.loading = false
      },
      error: () => (this.loading = false)
    })
  }

  changeFilter(type: 'month' | 'week' | 'lastWeek' | 'year' | 'today', section?: string) {
    const label = this.getFilterLabel(type, section)
    console.log(section, type)

    if (section === 'employees by department') {
      this.selectedFilter = type
      this.selectedFilterLabel = label

      this.loadChartData()
    } else if (section === 'attendance overview') {
      this.selectedFilterOverview = type
      this.selectedFilterOverviewLabel = label
      this.loadAttendanceOverview()
    } else if (section === 'clock in out') {
      this.selectedFilterClockInOut = type
      this.selectedFilterClockInOutLabel = label
    }
  }

  loadChartData() {
    const params = `filter=${this.selectedFilter}`

    this.userService.getEmployeeChartData(params).subscribe(res => {
      this.chartData = res.chartData
      this.maxLimit = res.maxLimit

      this.thisPeriodCount = res.stats.thisPeriodCount
      this.lastPeriodCount = res.stats.lastPeriodCount
      this.increasePercentage = res.stats.changePercent
      this.trendText = res.stats.trend

      this.chartOptions = {
        series: [
          {
            name: 'Employees',
            data: this.chartData.map(d => d.y)
          }
        ],
        // chart: {
        //   type: 'line',
        //   height: 300,
        //   toolbar: { show: false }
        // },
        chart: {
          type: 'area',
          height: 320,
          toolbar: { show: false },
          zoom: { enabled: false }
        },
        fill: {
          type: 'gradient',
          gradient: {
            // shadeIntensity: 1,
            // opacityFrom: 0.4,
            // opacityTo: 0.1
            shadeIntensity: 1,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [0, 90, 100]
          }
        },
        grid: {
          borderColor: '#f1f1f1'
        },
        stroke: {
          curve: 'smooth',
          width: 3
        },
        xaxis: {
          categories: this.chartData.map(d => d.x)
        },
        yaxis: {
          min: 1,
          labels: {
            formatter: (value: number) => Math.round(value).toString()
          }
        },
        markers: {
          size: 5
        },
        // colors: ['#4caf50'],
        colors: ['#f26522'],
        dataLabels: {
          enabled: false
        }
      }
    })
  }

  setTodayIndex(chartType: 'week' | 'month' | 'year') {
    const today = new Date()
    switch (chartType) {
      case 'week':
        this.todayIndex = today.getDay() // 0 = Sun
        break
      case 'month':
        this.todayIndex = today.getDate() - 1 // 0-based index
        break
      case 'year':
        this.todayIndex = today.getMonth() // 0 = Jan
        break
    }
  }
  private getFilterLabel(
    type: 'month' | 'week' | 'lastWeek' | 'year' | 'today',
    section?: string
  ): string {
    switch (type) {
      case 'today':
        return 'Today'

      case 'week':
        return 'This Week'

      case 'lastWeek':
        return 'Last Week'

      case 'month':
        return 'This Month'

      case 'year':
        return 'This Year'

      default:
        return ''
    }
  }
  get thisLabel(): string {
    switch (this.selectedFilter) {
      case 'week':
        return 'this Week'
      case 'lastWeek':
        return 'last Week'
      case 'month':
        return 'this Month'
      case 'year':
        return 'this Year'
      default:
        return 'this Period'
    }
  }
  get lastLabel(): string {
    switch (this.selectedFilter) {
      case 'week':
        return 'last Week'
      case 'lastWeek':
        return 'prev Week'
      case 'month':
        return 'last Month'
      case 'year':
        return 'last Year'
      default:
        return 'last Period'
    }
  }

  getLineChartPoints(): string {
    const weekMap = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const today = new Date()

    const todayDay = today.getDate()
    const todayWeekDay = today.getDay()
    const todayMonth = today.getMonth()

    return this.chartData
      .map((point, i) => {
        if (this.selectedFilter === 'month') {
          const pointDay = Number(point.x)
          if (pointDay > todayDay && point.y === 0) return null
        }

        if (this.selectedFilter === 'week') {
          const pointDayIndex = weekMap.indexOf(point.x)
          if (pointDayIndex > todayWeekDay && point.y === 0) return null
        }

        if (this.selectedFilter === 'year') {
          if (i > todayMonth && point.y === 0) return null
        }

        return `${this.getPointX(i)},${this.getPointY(point.y)}`
      })
      .filter(p => p !== null)
      .join(' ')
  }

  buildChart() {
    const max = Math.max(...this.chartData.map(d => d.y))
    const stepX = 100 / (this.chartData.length - 1)

    this.points = this.chartData.map((d, i) => ({
      x: stepX * i,
      y: (d.y / max) * 100,
      value: d.y
    }))

    // Create connecting lines
    for (let i = 0; i < this.points.length - 1; i++) {
      const p1 = this.points[i]
      const p2 = this.points[i + 1]

      const dx = p2.x - p1.x
      const dy = p2.y - p1.y
      const length = Math.sqrt(dx * dx + dy * dy)
      const angle = Math.atan2(dy, dx) * (180 / Math.PI)

      this.segments.push({
        left: p1.x + '%',
        bottom: p1.y + '%',
        width: length + '%',
        transform: `rotate(${angle}deg)`
      })
    }
  }

  isFutureZero(point: any, i: number): boolean {
    const weekMap = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const today = new Date()

    if (this.selectedFilter === 'month') {
      return Number(point.x) > today.getDate() && point.y === 0
    }

    if (this.selectedFilter === 'week') {
      return weekMap.indexOf(point.x) > today.getDay() && point.y === 0
    }

    if (this.selectedFilter === 'year') {
      return i > today.getMonth() && point.y === 0
    }

    return false
  }

  getPointX(i: number): number {
    return i * (460 / this.chartData.length) + 50 + 460 / this.chartData.length / 2
  }

  getPointY(value: number): number {
    return 270 - (Math.min(value, this.maxLimit) / this.maxLimit) * 300
  }

  loadStatusChartData() {
    this.userService.getEmployeeStatusChartData().subscribe(res => {
      this.employeeStats = res.employeeTypeStats
      this.employeeCount = res.totalCount
    })
  }
  ngAfterViewInit() {
    this.drawGauge()
  }

  loadAttendanceOverview() {
    const params = `filter=${this.selectedFilterOverview}`

    this.attendancePolicyService.getSummary(params).subscribe(res => {
      this.total = res.total
      this.present = res.presentPercent
      this.late = res.latePercent
      this.leave = res.leavePercent
      this.absent = res.absentPercent

      this.presentCount = res.presentCount
      this.lateCount = res.lateCount
      this.leaveCount = res.leaveCount
      this.absentCount = res.absentCount

      this.hasData = this.total >= 0

      if (this.hasData) {
        setTimeout(() => this.drawGauge(), 0)
      }
    })
  }

  getDashArray(value: number) {
    const circumference = 440
    return `${(value / 100) * circumference} ${circumference}`
  }

  drawGauge() {
    const canvas = this.attendanceCanvas.nativeElement
    const ctx = canvas.getContext('2d')!
    ctx.clearRect(0, 0, canvas.width, canvas.height)

    const cx = canvas.width / 2
    const cy = canvas.height - 20
    const radius = 100
    const thickness = 30
    const totalAngle = Math.PI // half-circle
    const gap = 0.02 // gap between segments

    // Attendance data
    const data = [
      { label: 'Present', value: this.presentCount, color: '#00c853' },
      { label: 'Late', value: this.lateCount, color: '#083d4f' },
      { label: 'Leaves', value: this.leaveCount, color: '#ffc107' },
      { label: 'Absent', value: this.absentCount, color: '#e53935' }
    ]

    const total = data.reduce((sum, item) => sum + item.value, 0)

    let startAngle = Math.PI // start from left side
    this.segments = []

    data.forEach(item => {
      if (item.value <= 0) return // skip zero values

      const segmentAngle = (item.value / total) * totalAngle
      const drawAngle = segmentAngle - gap

      if (drawAngle <= 0) {
        startAngle += segmentAngle
        return
      }

      const segStart = startAngle + gap / 2
      const segEnd = segStart + drawAngle

      // Draw segment
      ctx.beginPath()
      ctx.arc(cx, cy, radius, segStart, segEnd)
      ctx.lineWidth = thickness
      ctx.strokeStyle = item.color
      ctx.lineCap = 'round'
      ctx.stroke()

      // Store for hover
      this.segments.push({
        start: segStart,
        end: segEnd,
        label: item.label,
        value: item.value,
        percent: ((item.value / total) * 100).toFixed(0) // store percentage
      })

      startAngle += segmentAngle
    })

    // Draw total text
    ctx.textAlign = 'center'
    ctx.fillStyle = '#6c757d'
    ctx.font = '14px Arial'
    ctx.fillText('Total Attendance', cx, cy - 40)

    ctx.fillStyle = '#0b1b34'
    ctx.font = 'bold 28px Arial'
    ctx.fillText(String(total), cx, cy - 10)

    this.addHoverListener(canvas, cx, cy, radius, thickness)
  }

  addHoverListener(
    canvas: HTMLCanvasElement,
    cx: number,
    cy: number,
    r: number,
    thickness: number
  ) {
    canvas.onmousemove = e => {
      const rect = canvas.getBoundingClientRect()

      // Mouse position inside canvas
      const canvasX = e.clientX - rect.left
      const canvasY = e.clientY - rect.top

      const dx = canvasX - cx
      const dy = canvasY - cy
      const distance = Math.sqrt(dx * dx + dy * dy)

      if (distance <= r + thickness / 2 && distance >= r - thickness / 2) {
        let angle = Math.atan2(dy, dx)
        if (angle < 0) angle += 2 * Math.PI

        for (const seg of this.segments) {
          if (angle >= seg.start && angle <= seg.end) {
            this.zone.run(() => {
              this.tooltip = {
                show: true,
                x: canvasX, // ✅ relative to container
                y: canvasY - 30, // ✅ relative to container
                label: seg.label,
                value: parseInt(seg.percent),
                percent: seg.percent + '%'
              }
            })

            return
          }
        }
      }

      this.zone.run(() => {
        this.tooltip.show = false
      })
    }
  }
  @HostListener('window:scroll')
  onWindowScroll() {
    this.tooltip.show = false
  }

  loadAttendance() {
    this.clockInOutService.getTodayClockIns().subscribe((res: any) => {
      this.onTimeUsers = res.onTimeUsers
      this.lateUsers = res.lateUsers
      console.log(this.lateUsers)
    })
  }

  toggleUserDetails(user: any) {
    this.expandedUser = this.expandedUser === user.id ? null : user.id
  }

  punchIn(): void {
    //this.punchService.punchIn()
    //this.punchInTime = new Date().toISOString()
    // Get just the time portion of the current date
    // const timeString = new Date(this.punchInTime).toTimeString().split(' ')[0]; // Extract "HH:mm:ss"
    //const employeeData = {
    //  employeeId: this.employeeId,
    //  clockIn: this.punchInTime
    //}
    // this.punchService.punchApi.createPunch(employeeData).subscribe({
    //     next: (response) => {
    //         this.id = response.data.id;
    //         console.log('response', response.data.id)
    //       if (response.status) {
    //         this.id = response.data.id;
    //         console.log('response', response.data.id)
    //         // console.log('Business created successfully:', response.message);
    //         alert('ClockIn created successfully!');
    //       } else {
    //         // console.error('Business creation failed:', response.message);
    //         alert('Failed to create clockIn: ' + response.message);
    //       }
    //     },
    //     error: (err) => {
    //       // console.error('Error occurred during API call:', err);
    //       alert('An error occurred while creating the clockIn.');
    //     }
    //   });
    //const result = this.punchService.create(employeeData).subscribe(response => {
    //  this.id = response.id
    //  this.isPunchedIn = true
    //  this.startPunchTimer()
    //  // console.log('api response:', response)
    //})
  }

  loadBirthdays() {
    this.userService.getCelebrations({ month: true, type: 'birthday' }).subscribe((res: any) => {
      this.todayBirthdays = res.today || []
      this.tomorrowBirthdays = res.tomorrow || []
      this.upcomingBirthdays = res.upcoming || []
    })
  }

  formatBirthday(dateStr: string): string {
    const date = new Date(dateStr)

    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short'
    }) // 20 Feb
  }

  loadAnniversaries() {
    this.userService.getCelebrations({ month: true, type: 'anniversary' }).subscribe((res: any) => {
      if (res.type === 'monthly') {
        this.todayAnniversaries = res.today || []
        this.tomorrowAnniversaries = res.tomorrow || []
        this.upcomingAnniversaries = res.upcoming || []
      }
    })
  }

  formatAnniversary(date: string) {
    return new Date(date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })
  }

  getWorkYears(joinDate: string): number {
    const join = new Date(joinDate)
    const now = new Date()
    return now.getFullYear() - join.getFullYear()
  }

  punchOut(): void {
    //this.punchService.punchOut()
    //this.punchOutTime = new Date().toISOString()
    //// Get just the time portion of the current date
    //// const timeString = new Date(this.punchOutTime).toTimeString().split(' ')[0]; // Extract "HH:mm:ss"
    //if (this.punchInTime) {
    //  const punchIn = new Date(this.punchInTime) // Convert punchInTime to Date
    //  const currentTime = new Date() // Get the current time
    //  // Calculate the difference in milliseconds
    //  const diffInMs = currentTime.getTime() - punchIn.getTime()
    //  if (diffInMs > 60000) {
    //    const model = {
    //      id: this.id,
    //      clockOut: this.punchOutTime
    //    }
    //    this.punchService.update(this.id, model).subscribe(() => {
    //      this.isPunchedIn = false
    //      this.getLatestPunchIn()
    //      // this.punchService.get(this.employeeId).subscribe((res) => {
    //      //     const clockInResponse = res.clockinout;
    //      //     let totalMilliseconds = 0;
    //      //     clockInResponse.forEach(record => {
    //      //         const clockIn = new Date(record.clockIn);
    //      //         const clockOut = new Date(record.clockOut);
    //      //         // Calculate the difference in milliseconds
    //      //         const diff = clockOut.getTime() - clockIn.getTime();
    //      //         totalMilliseconds += diff;
    //      //         // console.log('total miliseconds: ', totalMilliseconds)
    //      //     });
    //      //     // Convert milliseconds to hours
    //      //     // this.totalWorkedHours = totalMilliseconds / (1000 * 60 * 60); // milliseconds to hours
    //      //     const diffInMinutes = Math.floor(totalMilliseconds / (1000 * 60)); // Convert milliseconds to minutes
    //      //     const hours = Math.floor(diffInMinutes / 60); // Get the hours
    //      //     const minutes = (diffInMinutes % 60).toFixed(2); // Get the remaining minutes
    //      //     // Display hours and minutes in the format "X hours Y minutes"
    //      //     // this.totalWorkedHours = `${hours} hour${hours !== 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
    //      //     // this.totalWorkedHours = `${hours}.${parseFloat(minutes)} `;
    //      //     this.totalWorkedHours = hours;
    //      //     this.totalWorkedMinutes = parseFloat(minutes);
    //      // })
    //    })
    //    this._notifications.success('SUCCESS', 'Punch Out Successfully.', {
    //      timeOut: 5000,
    //      showProgressBar: true
    //    })
    //  } else {
    //    // alert('you couldnot punchout before 1 minute.');
    //    this._notifications.warn('ERROR', "You couldn't punchout before 1 minute.", {
    //      timeOut: 5000,
    //      showProgressBar: true
    //    })
    //  }
    //}
    // console.log('punch out', this.id)
  }

  // Start a timer to update punch hours every minute (or second if needed)
  startPunchTimer(): void {
    this.intervalId = setInterval(() => {
      this.calculatePunchHours() // Recalculate every minute
    }, 60000) // 60000 ms = 1 minute
  }

  // Updated punch.component.ts
  calculatePunchHours(): void {
    // Check if punchInTime exists
    //if (this.punchInTime) {
    //  const punchIn = new Date(this.punchInTime) // Convert punchInTime to Date
    //  const currentTime = new Date() // Get the current time
    //  // Calculate the difference in milliseconds
    //  const diffInMs = currentTime.getTime() - punchIn.getTime()
    //  // Convert milliseconds to total minutes
    //  const diffInMinutes = Math.floor(diffInMs / (1000 * 60)) // Minutes as an integer
    //  // Calculate total hours and minutes
    //  const hours = Math.floor(diffInMinutes / 60) // Total hours from the difference
    //  const minutes = diffInMinutes % 60 // Remaining minutes after full hours
    //  // Add the current total worked hours and minutes to the calculated time
    //  const totalHours = hours + this.totalWorkedHours // Total hours including previous hours worked
    //  let totalMinutes = minutes + this.totalWorkedMinutes // Total minutes including previous minutes worked
    //  // console.log('hours', hours);
    //  // console.log('minutes', minutes);
    //  // console.log('total hours', totalHours);
    //  // console.log('total minures', totalMinutes);
    //  // console.log('total worked hours', this.totalWorkedHours);
    //  // console.log('total worked minutes', this.totalWorkedMinutes);
    //  // Handle overflow of minutes into hours
    //  if (totalMinutes >= 60) {
    //    this.gpsWorkedHours = totalHours + Math.floor(totalMinutes / 60) // Add full hours from minutes overflow
    //    this.gpsWorkedMinutes = totalMinutes % 60 // Remaining minutes after conversion to hours
    //  } else {
    //    this.gpsWorkedHours = totalHours // Set total hours
    //    this.gpsWorkedMinutes = totalMinutes // Set total minutes
    //  }
    //  // Log the final values for debugging
    //  //console.log(`Total Worked Hours: ${this.totalWorkedHours}`)
    //  //console.log(`Total Worked Minutes: ${this.totalWorkedMinutes}`)
    //} else {
    //  //console.warn('No punch-in time available')
    //}
  }

  getEmployee(): void {
    //if (this.userId) {
    //  this.employeeService.employeeApi.getItemById(this.userId).subscribe(
    //    data => {
    //      this.itemData = data.id
    //      this.employeeId = data.id
    //      //   console.log('Fetched item data:', this.itemData);
    //      if (data.user && data.user.role == 'Employee') {
    //        this.getLatestPunchIn()
    //      }
    //    },
    //    error => {
    //      console.error('Error fetching item data:', error)
    //    }
    //  )
    //}
  }

  getLatestPunchIn(): void {
    //this.punchService.punchApi.getLatestPunch(this.employeeId).subscribe(
    //  (response: unknown) => {
    //    //this.itemData = response
    //    ////   this.employeeId = data.id;
    //    ////   console.log('Fetched latest punch in:', this.itemData);
    //    //// this.clockInTime = data.clockIn,
    //    //this.id = response.data.id
    //    //// this.totalWorkedHours = response.result.totalWorkHours.toFixed(2);
    //    //const totalWorkHours = parseFloat(response.result.totalWorkHours.toFixed(2))
    //    //// Extract the hours (integer part)
    //    //const totalHours = Math.floor(totalWorkHours)
    //    //// Extract the decimal part (minutes), then convert to minutes
    //    //const totalMinutes = Math.round((totalWorkHours - totalHours) * 60) // Multiply decimal part by 60 to convert to minutes
    //    //// Save to the respective fields
    //    //this.totalWorkedHours = totalHours // Save as totalHours
    //    //this.totalWorkedMinutes = totalMinutes // Save the minutes
    //    //this.gpsWorkedHours = totalHours // Save as totalHours
    //    //this.gpsWorkedMinutes = totalMinutes // Save the minutes
    //    //console.log('total ', this.totalWorkedHours)
    //    //console.log('total', this.totalWorkedMinutes)
    //    //if (response.data.clockOut == null && response.data.clockIn != null) {
    //    //  this.isPunchedIn = true
    //    //  this.punchInTime = response.data.clockIn
    //    //  this.calculatePunchHours()
    //    //  this.startPunchTimer()
    //    //}
    //  },
    //  () => {
    //    //console.error('Error fetching item data:', error)
    //  }
    //)
  }

  getUser(): void {
    // this.__route.paramMap.subscribe(params => {
    //     //   this.token = (params.get('token') || '');
    //       if (this.token) {
    //         this.__adminUserService.adminApi.getTokenedUser({ token: this.authService.getToken() }).subscribe(async (response) => {
    //         //   let { email, id } = response;
    //         //   this.id = id;
    //         //   this.registerForm.controls['email'].setValue(email);
    //         console.log('get user', response);
    //         }, err => {
    //           console.error(err);
    //           this._notifications.error("ERROR", err.error && err.error.message || err.message || "", {})
    //         })
    //       }
    //     })
    //    this.__adminUserService.adminApi.get(this.userId).subscribe((response)=>{
    //     // console.log('dashboard user response: ', response)
    //     this.user = response;
    //     if(this.user.role == "Employee"){
    //         this.getEmployee();
    //     }
    //    });
    //    console.log('user:', this.user)
    //const userData = firstValueFrom(this.__adminUserService.user$)
    //this.user = userData
    //if (this.user) {
    //  if (this.user.role === 'Employee') {
    //  }
    //}
  }
}
